export default "__VITE_ASSET__CseOUOtV__"